import Slider from './Slider.jsx';

export default Slider;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Slider/index.js